import client from '../../../config/api';
import {
  LOCAL_APPEND_CHANGELOG_PAGE,
  LOCAL_RESET_CHANGELOG,
} from '../mutations/mutationTypes';

const PAGE_SIZE = 50;

export default {
  async GET_JOB_CHANGELOG(
    { commit, state },
    { jobId, reset = false, entityType = null, action = null }
  ) {
    const params = { limit: PAGE_SIZE };
    if (!reset && state.lastEvaluatedKey) {
      params.startKey = state.lastEvaluatedKey;
    }
    if (entityType) {
      params.entityType = entityType;
    }
    if (action) {
      params.action = action;
    }

    const result = await client.get(`/job/${jobId}/changelog`, { params });

    if (!result || !result.data) {
      return null;
    }

    commit(LOCAL_APPEND_CHANGELOG_PAGE, {
      items: result.data.items || [],
      lastEvaluatedKey: result.data.lastEvaluatedKey,
      reset,
    });

    return result.data;
  },

  RESET_JOB_CHANGELOG({ commit }) {
    commit(LOCAL_RESET_CHANGELOG);
  },
};
